/* eslint-disable no-unused-vars */
import anime from 'animejs';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination])

export default {
  init() {
    const setProgress = function(swiper) {
      const prevIndex = swiper.previousIndex
      const realIndex = swiper.realIndex
      const index = realIndex + 1
      //document.getElementById('projectIndex').innerHTML = (index + '').padStart(2, '0')
      document.querySelectorAll('.project-index').forEach((bigNumber) => {
        bigNumber.innerHTML = (index + '').padStart(2, '0')
      });
      document.querySelector('#projects-progress .progress-bar').style.width = index / swiper.slides.length * 100 + '%'
      const currents = Array.from(document.getElementsByClassName('current-project'))
      const next = Array.from(document.getElementsByClassName('next-project'))

      if(currents[prevIndex]) currents[prevIndex].classList.add('opacity-0')
      if(next[prevIndex]) next[prevIndex].classList.add('opacity-0')
      setTimeout(() => {
        if(currents[prevIndex]) currents[prevIndex].classList.add('d-none')
        currents[realIndex].classList.remove('d-none')
        if(next[prevIndex]) next[prevIndex].classList.add('d-none')
        next[realIndex].classList.remove('d-none')

        setTimeout(() => {
          currents[realIndex].classList.remove('opacity-0')
          next[realIndex].classList.remove('opacity-0')
        }, 50);                
      }, 350);
      anime({
        targets: swiper.slides[prevIndex],
        duration: 500,
        opacity: 0,
        easing: 'easeOutSine',
        autoplay: true,
        complete: () =>
        {
          if(swiper.slides[prevIndex]) swiper.slides[prevIndex].style.opacity = 1
        },
      })
    }
    const swiperProjects = new Swiper('.swiper-projects .swiper', {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      spaceBetween: 36,
      speed: 500,
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-projects .swiper-button-next',
        prevEl: '.swiper-projects .swiper-button-prev',
      },

      on: {
        slideChange: setProgress,
      },
      breakpoints: {
        992: {
          allowTouchMove: false,
        },
      },
    })
    setProgress(swiperProjects)
    const swiperPoints = new Swiper('.swiper-points', {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      freeMode: false,
      spaceBetween: 60,
      slidesPerView: 1.2,
    
      // If we need pagination
      pagination: {
        el: '.swiper-points .swiper-pagination',
      },
    })

    const duration = 60000

    Array.from(document.getElementsByClassName('move-text')).forEach(mt =>
      {
        const ps = mt.getElementsByTagName('p')
        const translateAnimation = (t, s) =>
        {
          const a = anime({
            targets: t,
            translateX: ['100%', '-100%'],
            duration: duration,
            loop: true,
            easing: 'linear',
          })
          a.play()
          a.pause()
          a.seek(s)
          a.play()
        }
        translateAnimation(ps[0], duration/2)
        translateAnimation(ps[1], 0)
      })

      Array.from(document.getElementsByClassName('move-text-inverse')).forEach(mt =>
        {
          const ps = mt.getElementsByTagName('p')
          const translateAnimation = (t, s) =>
          {
            const a = anime({
              targets: t,
              translateX: ['-100%', '100%'],
              duration: duration,
              loop: true,
              easing: 'linear',
            })
            a.play()
            a.pause()
            a.seek(s)
            a.play()
          }
          translateAnimation(ps[0], duration/2)
          translateAnimation(ps[1], 0)
        })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js